import firebase from 'firebase/app'
import FirebaseError from '../errors/firebase-error';
import { initFirebase } from './init';

export const getLatestVersion = async (id) => {
    initFirebase();
    const db = firebase.firestore();
    const docRef = db.collection("versions").doc(id);
    let doc = null;
    try {
        doc = await docRef.get();
    } catch (error) {
        // window.captureException(error);
        // throw new FirebaseError(error);
        return null;
    }
    if (!doc.exists) {
        // throw new FirebaseError('Document not found');
        return null;
    }
    return doc.data();
}
